export default function TS_Get_Started() {
  return (
    <div>
      <h1>TS Get Started</h1>
      <p>This is the TS Get Started page.</p>
    </div>
  );
}